/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AnimaticValueItem,
  AnimaticValueItem$inboundSchema,
} from "./animaticvalueitem.js";

/**
 * Specifies details for a value shelf that is shown below an Equipment Browser Item.
 */
export type AnimaticValueShelf = {
  /**
   * The items to display on the shelf
   */
  items: Array<AnimaticValueItem>;
};

/** @internal */
export const AnimaticValueShelf$inboundSchema: z.ZodType<
  AnimaticValueShelf,
  z.ZodTypeDef,
  unknown
> = z.object({
  items: z.array(AnimaticValueItem$inboundSchema),
});

export function animaticValueShelfFromJSON(
  jsonString: string,
): SafeParseResult<AnimaticValueShelf, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AnimaticValueShelf$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AnimaticValueShelf' from JSON`,
  );
}
